export enum DisplayTypes {
    ROOM_DISPLAY = "ROOM_DISPLAY",
    MEETING_DISPLAY = "MEETING_DISPLAY",
    GUEST_CHECK_IN = "GUEST_CHECK_IN",
}

export interface CreateDisplayFormValues {
    type: DisplayTypes
    name: string
    isActive?: boolean
    serialNumber: string
    deviceNumber: string
    floor?: number
    room?: {
        id?: number
        name?: string
    }
    templateId?: number
}

export type DeviceTemplate = Readonly<{
    id: number
    type: string
}>

export type ApiRoomDisplay = Omit<CreateDisplayFormValues, "templateId" | "room"> & {
    template: {
        id?: number
    }
    serviceCenter?: {
        id?: number
    }
    meetingDisplayDetails?: {
        floor: number
    }
}
